import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function UnutkanlikTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['unutkanlik-testi']} />;
}
